import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { SchemaOrg, organizationSchema } from '../../utils/seo';

const categories = ['すべて', '保険ニュース', '地域情報', 'お客様事例'];

const articles = [
  {
    id: 1,
    title: '2025年度 火災保険改定のポイント',
    excerpt: '2025年1月から火災保険の制度が一部改定されました。岡山市にお住まいの皆さまに影響する主な変更点をわかりやすく解説いたします。',
    category: '保険ニュース',
    date: '2025-01-15',
    image: 'https://public.readdy.ai/ai/img_res/f18072631330c438d09ea7e9a1b2211b.jpg',
  },
  {
    id: 2,
    title: '岡山市の子育て世代におすすめの学資保険',
    excerpt: '教育費の準備は早めが肝心。岡山市の平均的な教育費データを基に、効果的な学資保険の活用方法をご紹介します。',
    category: '保険ニュース',
    date: '2025-01-10',
    image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20family%20with%20young%20children%20studying%20together%20at%20home%2C%20parents%20helping%20kids%20with%20homework%2C%20warm%20cozy%20living%20room%2C%20natural%20lighting%2C%20authentic%20Japanese%20people%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=education-insurance-001&orientation=landscape',
  },
  {
    id: 3,
    title: '台風シーズン前に確認したい保険の補償内容',
    excerpt: '岡山県でも近年台風による被害が増えています。火災保険や自動車保険で台風被害がどこまでカバーされるか確認しておきましょう。',
    category: '保険ニュース',
    date: '2025-01-05',
    image: 'https://readdy.ai/api/search-image?query=Stormy%20weather%20over%20residential%20area%20in%20Japan%2C%20typhoon%20preparation%20concept%2C%20dark%20clouds%20over%20houses%2C%20dramatic%20natural%20lighting%2C%20professional%20weather%20photography%2C%20simple%20background%20without%20text&width=600&height=400&seq=typhoon-insurance-001&orientation=landscape',
  },
  {
    id: 4,
    title: 'お客様インタビュー: 保険見直しで年間5万円削減',
    excerpt: '倉敷市在住のF様（40代）にお話を伺いました。家族構成の変化に合わせた保険見直しで、保障を充実させながら保険料を削減できました。',
    category: 'お客様事例',
    date: '2024-12-28',
    image: 'https://readdy.ai/api/search-image?query=Happy%20Japanese%20family%20of%20four%20at%20their%20home%20in%20Kurashiki%2C%20parents%20with%20two%20children%20smiling%20in%20living%20room%2C%20natural%20lighting%2C%20casual%20comfortable%20clothing%2C%20authentic%20Japanese%20people%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=customer-story-001&orientation=landscape',
  },
  {
    id: 5,
    title: '倉敷市での無料相談会開催レポート',
    excerpt: '12月に倉敷市で開催した保険相談会には50組を超えるご家族にご参加いただきました。地域の皆さまとの交流の様子をレポートします。',
    category: '地域情報',
    date: '2024-12-20',
    image: 'https://readdy.ai/api/search-image?query=Community%20consultation%20event%20in%20Kurashiki%20city%2C%20Japanese%20people%20attending%20insurance%20seminar%2C%20friendly%20atmosphere%20at%20local%20venue%2C%20natural%20lighting%2C%20authentic%20Japanese%20participants%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=consultation-event-001&orientation=landscape',
  },
  {
    id: 6,
    title: '新入社員向け: 初めての保険選び',
    excerpt: '社会人になったら考えたい保険選び。岡山市で働く新入社員の皆さまに向けて、最低限必要な保険と選び方のポイントを解説します。',
    category: '保険ニュース',
    date: '2024-12-15',
    image: 'https://readdy.ai/api/search-image?query=Young%20Japanese%20professional%20in%20business%20suit%20smiling%20confidently%20at%20modern%20office%2C%20new%20graduate%20employee%2C%20bright%20office%20environment%2C%20natural%20lighting%2C%20authentic%20Japanese%20person%20in%20their%2020s%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=new-employee-001&orientation=landscape',
  },
  {
    id: 7,
    title: '岡山後楽園での地域防災イベントに参加',
    excerpt: '岡山市主催の防災イベントに参加し、災害時の保険手続きについて情報提供を行いました。地域の防災意識向上に貢献できました。',
    category: '地域情報',
    date: '2024-12-10',
    image: 'https://readdy.ai/api/search-image?query=Disaster%20prevention%20event%20at%20Okayama%20Korakuen%20Garden%2C%20community%20gathering%20for%20safety%20awareness%2C%20Japanese%20people%20participating%20in%20local%20event%2C%20natural%20outdoor%20setting%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=disaster-event-001&orientation=landscape',
  },
  {
    id: 8,
    title: 'シニア世代の医療保険見直しポイント',
    excerpt: '50代を迎えたら考えたい医療保険の見直し。総社市のK様のケースを例に、シニア世代に適した医療保障の選び方をご紹介します。',
    category: 'お客様事例',
    date: '2024-12-05',
    image: 'https://readdy.ai/api/search-image?query=Senior%20Japanese%20couple%20in%20their%2060s%20consulting%20with%20insurance%20advisor%2C%20friendly%20professional%20meeting%2C%20modern%20office%20setting%2C%20natural%20lighting%2C%20authentic%20Japanese%20people%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=senior-consultation-001&orientation=landscape',
  },
  {
    id: 9,
    title: '岡山市北区での出張相談サービス開始',
    excerpt: 'ご要望にお応えし、岡山市北区エリアでの出張相談サービスを本格的に開始いたします。ご自宅やお近くのカフェでの相談が可能になりました。',
    category: '地域情報',
    date: '2024-11-30',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20insurance%20consultant%20visiting%20customer%20home%20in%20Okayama%2C%20friendly%20home%20consultation%20meeting%2C%20cozy%20living%20room%20setting%2C%20natural%20lighting%2C%20authentic%20Japanese%20people%2C%20simple%20clean%20background%20without%20text&width=600&height=400&seq=home-visit-001&orientation=landscape',
  },
];

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('すべて');
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 6;
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const filteredArticles = selectedCategory === 'すべて' 
    ? articles 
    : articles.filter(article => article.category === selectedCategory);

  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);
  const startIndex = (currentPage - 1) * articlesPerPage;
  const currentArticles = filteredArticles.slice(startIndex, startIndex + articlesPerPage);

  const blogSchema = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: 'ブログ&新着情報 | おかやま保険株式会社',
    description: '保険の最新情報と地域のお役立ち情報をお届けします。',
    url: `${siteUrl}/blog`,
    publisher: organizationSchema,
    blogPost: articles.map((article) => ({
      '@type': 'BlogPosting',
      headline: article.title,
      description: article.excerpt,
      datePublished: article.date,
      author: organizationSchema,
      image: article.image,
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'ホーム',
        item: `${siteUrl}/`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'ブログ&新着情報',
        item: `${siteUrl}/blog`,
      },
    ],
  };

  return (
    <div className="min-h-screen bg-[#FAF8F3]">
      <SchemaOrg type="WebPage" data={blogSchema} />
      <SchemaOrg type="WebPage" data={breadcrumbSchema} />
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative flex items-center justify-center overflow-hidden" style={{ height: '40vh' }}>
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20blog%20and%20news%20concept%20with%20Japanese%20professionals%20reading%20and%20sharing%20information%2C%20digital%20communication%20atmosphere%2C%20clean%20contemporary%20office%20setting%2C%20natural%20lighting%2C%20simple%20clean%20background%20without%20text&width=1920&height=800&seq=blog-hero-001&orientation=landscape"
              alt="ブログ&新着情報"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/60"></div>
          </div>
          
          <div className="relative z-10 text-center text-white px-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 md:mb-4">ブログ&新着情報</h1>
            <p className="text-base sm:text-lg md:text-xl mb-3 md:mb-4">保険の最新情報と地域のお役立ち情報</p>
            <nav className="text-sm">
              <Link to="/" className="hover:text-[#FF9B7A] transition-colors cursor-pointer">ホーム</Link>
              <span className="mx-2">&gt;</span>
              <span>ブログ&新着情報</span>
            </nav>
          </div>
        </section>

        {/* Category Tabs */}
        <section className="py-8 md:py-12 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center justify-center gap-2 flex-wrap">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => {
                    setSelectedCategory(category);
                    setCurrentPage(1);
                  }}
                  className={`px-4 md:px-6 py-2 md:py-3 rounded-full text-sm md:text-base font-medium transition-all whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-[#FF9B7A] text-white shadow-lg'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Articles Grid */}
        <section className="py-8 md:py-12">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16">
              {currentArticles.map((article) => (
                <article key={article.id} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-[#FF9B7A] text-white px-3 py-1 rounded-full text-xs md:text-sm font-medium">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-5 md:p-6">
                    <time className="text-gray-500 text-xs md:text-sm mb-2 md:mb-3 block">
                      {new Date(article.date).toLocaleDateString('ja-JP', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </time>
                    
                    <h2 className="text-lg md:text-xl font-bold text-[#2C3E50] mb-2 md:mb-3 leading-tight line-clamp-2">
                      {article.title}
                    </h2>
                    
                    <p className="text-gray-600 text-xs md:text-sm leading-relaxed mb-3 md:mb-4 line-clamp-3">
                      {article.excerpt}
                    </p>
                    
                    <Link
                      to={`/blog/${article.id}`}
                      className="text-sm md:text-base text-[#FF9B7A] font-medium flex items-center gap-1 hover:gap-2 transition-all cursor-pointer"
                    >
                      続きを読む
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-10 h-10 rounded-full flex items-center justify-center text-sm md:text-base font-medium transition-colors cursor-pointer ${
                      currentPage === page
                        ? 'bg-[#FF9B7A] text-white'
                        : 'border border-gray-300 hover:bg-gray-50'
                    }`}
                  >
                    {page}
                  </button>
                ))}
                
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}